import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AuthRoutingModule } from './auth-routing.module';
import { ComponentsModule } from '../components/components.module';

import { AuthComponent } from './auth.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { LoginComponent } from './login/login.component';
import { ExternalLoginComponent } from './external-login/external-login.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import {MatDatepickerModule} from '@angular/material/datepicker';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { MatNativeDateModule } from '@angular/material/core';
import { ForgotPasswordRecoverComponent } from './forgot-password/forgot-password-recover/forgot-password-recover.component';
import { ForgotPasswordNewPasswordComponent } from './forgot-password/forgot-password-new-password/forgot-password-new-password.component';
import { GuidGuard } from '../guards/guid.guard';
import { ResetExpiredPasswordComponent } from './reset-expired-password/reset-expired-password.component';
import { CustomInputsModule } from '../form/custom-inputs/custom-inputs.module';
import { ExpiredPasswordMessageComponent } from './reset-expired-password/expired-password-message/expired-password-message.component';
import { RecaptchaModule } from 'ng-recaptcha-2';
import { MatSelectModule } from '@angular/material/select';
import { MatRadioModule } from '@angular/material/radio';


@NgModule({
  declarations: [
    AuthComponent,
    LoginComponent,
    ExternalLoginComponent,
    ForgotPasswordComponent,
    ForgotPasswordRecoverComponent,
    ForgotPasswordNewPasswordComponent,
    ResetExpiredPasswordComponent,
    ExpiredPasswordMessageComponent,
  ],
  imports: [
    CommonModule,
    AuthRoutingModule,
    FormsModule,
    CustomInputsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatCheckboxModule,
    MatButtonModule,
    MatIconModule,
    MatDatepickerModule,
    MatNativeDateModule,
    ComponentsModule,
    RecaptchaModule,
    NgxMaskDirective,
    NgxMaskPipe,
    MatSelectModule,
    MatRadioModule,
  ],
  providers: [
    provideNgxMask(),
    MatDatepickerModule,
    GuidGuard,
  ]

})
export class AuthModule { }
